import { IAdpVoucherHolder } from "./adp-voucher-holder";

export interface IAdpVoucherHolderResponse {
    data: {
        success: boolean;
        message: string;
        results: IAdpVoucherHolder
    }
}